'use strict';

(function () {
  'use strict';

  angular.module('msSleep').component('msDiaryTable', {
    templateUrl: 'sleep/templates/sleep-diary-table.html',
    controller: SleepDiaryTableCtrl,
    controllerAs: 'vm'
  });
  SleepDiaryTableCtrl.$inject = ['sleepEntrySvc', 'NotifyingSvc', '$timeout'];

  function SleepDiaryTableCtrl(sleepEntrySvc, NotifyingSvc, $timeout) {
    var vm = this;

    activate();

    ///////////////////////////////
    function activate() {
      sleepEntrySvc.getAllEntries().then(function (all) {
        vm.allEntries = all;
        $timeout(function () {
          return NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.PRINT_HTTP_COMPLETE);
        });
      });
    }
  }
})();